<template>
  <div>
    <v-autocomplete
      v-model="localValue"
      :items="contacts"
      :loading="fetching_contacts"
      :search-input.sync="search"
      :append-outer-icon="
        $store.getters['auth/getScope']('contacts.add')
          ? 'mdi-account-plus'
          : null
      "
      no-filter
      clearable
      v-bind="$attrs"
      return-object
      @click:append-outer="openContactDialog()"
    ></v-autocomplete>

    <v-card v-if="localValue.id && !hideDetailContact" outlined>
      <v-list-item>
        <v-list-item-avatar color="grey lighten-2">
          <v-icon
            v-text="localValue.type == 'F' ? 'mdi-account' : 'mdi-company'"
          ></v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ localValue.name }}</v-list-item-title>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_fiscal_number")) }}:
            {{ localValue.fiscal_number }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_email")) }}:
            {{ localValue.email }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_contact1")) }}:
            {{ localValue.contact1 }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_contact2")) }}:
            {{ localValue.contact2 }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_iban")) }}:
            {{ localValue.iban }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_gender")) }}:
            {{ localValue.gender }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            >{{ $capitalize($tc("model.select_contact_additional_info")) }}:
            {{ localValue.aditional_info }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn @click="openContactDialog(localValue.id)" icon>
            <v-icon size="21">mdi-pencil</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>

    <v-dialog v-model="contact_dialog" max-width="600px">
      <contact-form
        @cancel="handleCloseDialog"
        @submit="handleSubmitDialog"
        :id="edit_contact_id"
      ></contact-form>
    </v-dialog>
  </div>
</template>

<script>
import ContactForm from "@/components/forms/ContactForm";

export default {
  name: "select-contact",
  props: {
    value: {
      type: Object
    },
    hideDetailContact: {
      type: Boolean,
      default: false
    }
  },
  components: { ContactForm },
  data: () => ({
    search: "",
    contacts: [],
    fetching_contacts: false,
    contact: null,

    // Contact Dialog
    contact_dialog: false,
    edit_contact_id: null
  }),
  methods: {
    openContactDialog(edit_contact_id = null) {
      this.contact_dialog = true;
      this.edit_contact_id = edit_contact_id;
    },
    handleCloseDialog() {
      this.contact_dialog = false;
      this.edit_contact_id = null;
    },
    handleSubmitDialog(payload) {
      const found_contact = this.contacts.find(
        contact => contact.id == payload.id
      );

      if (found_contact) {
        this.contacts = this.contacts.map(contact => {
          if (contact.id == found_contact.id) {
            return payload;
          }

          return contact;
        });
      } else {
        this.contacts.push(payload);
      }

      this.localValue = payload;
      this.handleCloseDialog();
    },
    async fetchContacts(filter) {
      if (this.fetching_contacts) return;

      this.fetching_contacts = true;
      const response = await this.$http.get("/contacts", {
        params: { filter }
      });
      
      this.contacts =  response.data.data;
      this.fetching_contacts = false;
    },
    setInitialValue() {
      if (this.value) {
        this.localValue = this.value;
        this.contacts.push(this.value);
      }
    }
  },
  computed: {
    localValue: {
      get: function() {
        return this.contact ? this.contact : {};
      },
      set: function(newValue) {
        this.contact = newValue;

        if (newValue == null) {
          this.$emit("input", null);
          return;
        }
        this.$emit("input", newValue);
      }
    },
  },
  watch: {
    value(value) {
      if (!value) this.contact = null;
      this.setInitialValue();
    },
    search: _.debounce(function(value) {
      this.fetchContacts(value);
    }, 500)
  },
  created() {
    this.setInitialValue();
  }
};
</script>
